import React, { useState } from 'react';
import { Layout } from 'antd';
import MainMenu from './MainMenu';
import type { MenuItem } from './MainMenu';
import { useTheme } from '../../states/theme.atom';

const { Sider } = Layout;

export interface SideDrawerProps {
  menuItems: MenuItem[];
  logo?: React.ReactNode;
}

const SideDrawer: React.FC<SideDrawerProps> = ({ menuItems, logo }) => {
  const [collapsed, setCollapsed] = useState(false);
  const { theme: activeTheme } = useTheme();

  return (
    <Sider
      theme={activeTheme}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
    >
      {logo && <div className="text-center">{logo}</div>}
      <MainMenu items={menuItems} mode="inline" />
    </Sider>
  );
};

export default SideDrawer;
